/*
 * @Author: Dom
 * @Date: 2022-05-30 15:49:05
 * @LastEditTime: 2022-06-30 20:07:41
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\views\account\recharge\store.ts
 */
import { Mutation, Action } from 'vuex';
import { StoreModuleType } from "@/utils/store";
import { ResponseData } from '@/utils/request';
import {
    TableListQueryParams,
    TableDataType
} from './data.d';
import {
    getAccountRechargeFlowPageList
} from './service';

export interface StateType {
    errorMsg?: string;
    tableData: TableDataType;
}

export interface ModuleType extends StoreModuleType<StateType>{
    state: StateType;
    mutations: {
        changeErrorMsg: Mutation<StateType>;
        getRechargeList: Mutation<StateType>;
    };
    actions: {
        getRechargeFlowPageList: Action<StateType, StateType>;
    };
}

const initState: StateType = {
    errorMsg: undefined,
    tableData: {
        rechargelist: [],
        pagination: {
            total: 0,
            current: 1,
            pageNo: 1,
            pageSize: 10,
            showSizeChanger: true,
            showQuickJumper: true,
        },
    }
}

const StoreModel:ModuleType = {
    namespaced: true,
    name: 'rechargequery',
    state: {
        ...initState
    },
    mutations: {
        changeErrorMsg(state, payload) {
            state.errorMsg = payload;
        },
        getRechargeList(state, payload) {
            state.tableData = payload;
        }
    },
    actions: {
        //查询账号充值记录信息列表
        async getRechargeFlowPageList({commit},params:TableListQueryParams){
            let msg: string | undefined = undefined
            try{
                const req: ResponseData = await getAccountRechargeFlowPageList(params)
                const { body } = req
                const data = body?.datas || []
                commit('getRechargeList', {
                    ...initState.tableData,
                    rechargelist: data,
                    pagination: {
                        ...initState.tableData.pagination,
                        current: params.pageNo,
                        pageNo: params.pageNo,
                        pageSize: params.pageSize,
                        total: body.sumDataCount || 0,
                    }
                })
                msg = '';
            }catch(error:any){
                if (error.message && error.message === 'CustomError') {
                    const { response } = error;
                    const { data } = response;
                    msg = data.msg || 'error';
                }
            }
            commit('changeErrorMsg',msg);
            if (msg === '') {
                return true; // 成功
            } else if (typeof msg === 'undefined') {
                return undefined; // 服务器错误
            } else {
                return false; // 自定义错误
            }
        },
    }
}

export default StoreModel
